import { ZOOM_OPACITY_THRESHOLD } from "components/features/ProgressReportViewer/utils";
import { ZOOM_CONFIG } from "../../FloorPlanPanelNew/constants";
import { ZOOM_TO_OBJECT_VISIBLE_AREA } from "./constants";

interface ComputeZoomToObjectResult {
  zoom: number;
  panX: number;
  panY: number;
}

export const computeZoomToObject = (
  objectPosition: { x: number; y: number },
  containerWidth: number,
  containerHeight: number,
): ComputeZoomToObjectResult => {
  const targetZoom = Math.min(
    Math.max(
      containerWidth / ZOOM_TO_OBJECT_VISIBLE_AREA,
      ZOOM_OPACITY_THRESHOLD,
    ),
    ZOOM_CONFIG.MAX,
  );

  const containerCenterX = containerWidth / 2;
  const containerCenterY = containerHeight / 2;

  return {
    zoom: targetZoom,
    panX: containerCenterX - objectPosition.x * targetZoom,
    panY: containerCenterY - objectPosition.y * targetZoom,
  };
};
